import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import UserProfile from './components/UserProfile';
import Callback from './components/Callback';
import AuthHandler from './components/AuthHandler';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Routes>
      <Route path="/" element={<AuthHandler />} />
      <Route path="/callback" element={<Callback />} />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <UserProfile />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
